import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import Sidebar from "../Sidebar";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";

import Navbar from "../Navbar";
import Chat from "./Chat";
import NewChat from "./NewChat";
import { RecentPrompts } from "../pages/RecentPrompts";
import { RecommendedPrompts } from "../pages/RecommendedPrompts";
import { ReportTemplatesPicker } from "../pages/ReportTemplatesPicker";

import "./Dashboard.css";
import { Footer } from "../pages/Footer";

export const Dashboard = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [showReportTemplates, setShowReportTemplates] = useState(false);
  const handleCloseTemplateModal = () => setShowReportTemplates(false);

  const [partnerMetadata, setPartnerMetadata] = useState();
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  const [arePartnersAvailable, setArePartnersAvailable] = useState(true);

  const [selectedReport, setSelectedReportDashboard] = useState();
  var selected_index_prop = queryParameters.get("selected_index");
  if (selected_index_prop == undefined) {
    selected_index_prop = 0;
  }

  var selected_conversation_id = queryParameters.get("conversation_id");
  const [selectedConversationId, setConversationId] = useState(
    selected_conversation_id
  );

  const [selected_index, setSelectedIndex] = useState(selected_index_prop);
  const [recentPrompt, setRecentPrompt] = useState(selected_index_prop);

  const [updateChatLog, setUpdateChatLog] = useState();
  const [sendSlack, setSendSlack] = useState(true);

  const [emptyChat, setEmptyChat] = useState();
  const [updateConversations, setUpdateConversations] = useState();
  useEffect(() => {
    if (selected_index == undefined) {
      setSelectedIndex(0);
    }

    setRecentPrompt("");
  }, [selected_index, selectedReport]);

  function onCreateReport() {
    window.location.href =
      "/createReport?selected_index=" + selected_index_prop;
  }
  return (
    <div className="dashboard d-flex">
      <Modal
        show={showReportTemplates}
        onHide={handleCloseTemplateModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Your Jam Template</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReportTemplatesPicker />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseTemplateModal}>
            Close
          </Button>{" "}
        </Modal.Footer>
      </Modal>
      <div>
        <Sidebar
          selected_index={selected_index}
          setSelectedReport={setSelectedReportDashboard}
          setUpdateChatLogProp={setUpdateChatLog}
          setPartnerMetadata={setPartnerMetadata}
          updateConversations={updateConversations}
          partnerMetadata={partnerMetadata}
          setArePartnersAvailable={setArePartnersAvailable}
          setMessagesLoading={setMessagesLoading}
          selectedConversationId={selectedConversationId}
          setConversationId={setConversationId}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          height: "100vh",
          width: "100%",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Navbar
          selected_index={selected_index}
          partnerMetadata={partnerMetadata}
          setSelectedReportDashboard={setSelectedReportDashboard}
          setSendSlack={setSendSlack}
        />
        {messagesLoading ? (
          <div className="loadingMessagesView">
            {" "}
            <Spinner animation="border" variant="primary" />
            <p></p>
            Loading Messages...
          </div>
        ) : selectedReport !== undefined ? (
          <div className="chatView">
            <Chat
              selectedReport={selectedReport}
              onSelectReport={setSelectedReportDashboard}
              setUpdateChatLogProp={setUpdateChatLog}
              setUpdateConversations={setUpdateConversations}
              sendSlack={sendSlack}
              partnerMetadata={partnerMetadata}
            />
          </div>
        ) : (
          <div>
            <div className="newChat">
              {arePartnersAvailable ? (
                <div className="messageStart">
                  Welcome to the Jamafi Credit Copilot. Start a new conversation
                  below. Or you can select from Suggest or Trending Prompts.
                </div>
              ) : (
                <div className="messageStart">
                  {/* <img width="150px" height="150px" src={logo} alt=""></img> */}
                  <p>&nbsp;</p>It appears that you have no partners available at
                  the moment for {userProfile.email}
                </div>
              )}
              <p>&nbsp;</p>

              {partnerMetadata ? (
                <NewChat
                  className="chatView"
                  partnerMetadata={partnerMetadata}
                  setSelectedReport={setSelectedReportDashboard}
                  sendSlack={sendSlack}
                  recentPrompt={recentPrompt}
                />
              ) : (
                <div></div>
              )}
            </div>

            {arePartnersAvailable ? (
              <div>
                {" "}
                <div className="chatView">
                  <div className="dashboardMenuItem">
                    <RecommendedPrompts
                      setRecentPrompt={setRecentPrompt}
                      partnerMetadata={partnerMetadata}
                    />
                  </div>
                  <div className="dashboardMenuItem">
                    <RecentPrompts
                      setRecentPrompt={setRecentPrompt}
                      partnerMetadata={partnerMetadata}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
};
